import { styled } from '../../Utilities';
import { getStyles } from './Coachmark.styles';
import { CoachmarkBase } from './Coachmark.base';
export var Coachmark = styled(CoachmarkBase, getStyles, undefined, {
    scope: 'Coachmark'
});
//# sourceMappingURL=Coachmark.js.map